import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0200004e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "m-t-18 m-b-8"
}
const _hoisted_2 = {
  class: "flex",
  style: {"width":"fit-content"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "tech-campaign",
  class: "m-r-20 tech-campaign-label"
}, " Это техническая кампания ", -1))

import { ref, watch, computed } from "vue";
import { useRouter } from "vue-router";
import InputSwitch from "primevue/inputswitch";
import { useCampaignStore } from "@/store/campaigns/campaigns";
import {
  isTechCampaignConditionsMet,
  prepareTechCampaignSearchParams,
  prepareTechCampaignData,
} from "@/services/campaigns/techCampaign";
import { rootGetters } from "@/main";
import { useAuthStore } from "@/store/auth/login";
import type { Campaign } from "@/store/campaigns/campaigns";


export default /*#__PURE__*/_defineComponent({
  __name: 'TechCampaignToggle',
  props: {
    campaign: {},
    isLoadingData: { type: Boolean }
  },
  emits: ["update:campaign", "setLoading"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const router = useRouter();
const store = useCampaignStore();
const authStore = useAuthStore();
const isTechCampaign = ref(false);

watch(
  () => props.campaign,
  () => {
    if (isTechCampaign.value && !isTechCampaignConditionsMet(props.campaign)) {
      isTechCampaign.value = false;
    }
  },
  { deep: true }
);

const handleTechCampaignToggle = async (value: boolean) => {
  if (value) {
    try {
      await createOrOpenTechCampaign();
    } catch (error) {
      isTechCampaign.value = false;
    }
  } else {
    if (props.campaign.extra_info === "tech") {
      emit("update:campaign", {
        ...props.campaign,
        extra_info: "",
      });
    }
  }
};

const createOrOpenTechCampaign = async () => {
  if (!props.campaign.brand) {
    rootGetters.toast.show("warn", "Ошибка", "Необходимо выбрать бренд");
    return;
  }

  emit("setLoading", true);

  try {
    const params = prepareTechCampaignSearchParams(
      props.campaign.brand.brand_pk
    );

    await store.getCampaigns(params);

    if (store.campaignsList && store.campaignsList.length > 0) {
      const foundCampaign = store.campaignsList[0];
      rootGetters.toast.show(
        "info",
        "Информация",
        `Открыта существующая техническая кампания "${foundCampaign.name}"`
      );
      router.push({ name: "campaign", params: { id: foundCampaign.id } });
      return;
    }

    const techCampaignData = await prepareTechCampaignData();

    if (!techCampaignData) {
      const techShopId = rootGetters.tech_shop_id;
      rootGetters.toast.show(
        "warn",
        "Ошибка",
        techShopId
          ? `Магазин с id=${techShopId} не найден`
          : "Не указан shop_id в конфигурации приложения (VUE_APP_TECH_SHOP_ID)"
      );
      emit("setLoading", false);
      return;
    }

    emit("update:campaign", {
      ...props.campaign,
      shop: techCampaignData.shop,
      date_from: techCampaignData.startDate,
      date_to: techCampaignData.endDate,
      strategy: techCampaignData.strategy,
      extra_info: techCampaignData.extra_info,
    });

    isTechCampaign.value = true;

    rootGetters.toast.show(
      "info",
      "Информация",
      "Поля формы заполнены для создания технической кампании. Заполните сегменты и нажмите 'Отправить в рекламный кабинет'."
    );
  } catch (error: any) {
    rootGetters.toast.show(
      "error",
      "Ошибка",
      error.message ||
        error.response?.data?.detail ||
        "Произошла ошибка при поиске технической кампании"
    );
    isTechCampaign.value = false;
  } finally {
    emit("setLoading", false);
  }
};

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_unref(authStore).getPayloadTenant() == _unref(rootGetters).inhouse_tenant)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_unref(InputSwitch), {
            modelValue: isTechCampaign.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((isTechCampaign).value = $event)),
              handleTechCampaignToggle
            ],
            inputId: "tech-campaign",
            disabled: !_ctx.campaign.brand || _ctx.isLoadingData
          }, null, 8, ["modelValue", "disabled"])
        ])), [
          [
            _directive_tooltip,
            {
        value: !_ctx.campaign.brand ? 'Необходимо выбрать бренд' : '',
        class: 'white-tooltip-with-arrow',
        disabled: !!_ctx.campaign.brand,
      },
            void 0,
            { bottom: true }
          ]
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})